import table from './_table';
import last from './_last';

export const notifications = {
  namespaced: true,
  modules: {
    table,
    last
  }
};
